import { Component, OnInit } from '@angular/core';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { FormBuilder, Validators, AbstractControl, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { DatePipe } from '@angular/common';
import { CommonService } from 'app/_services/common.service'


@Component({
  selector: 'app-social-security',
  templateUrl: './social-security.component.html',
  styleUrls: ['./social-security.component.css']
})
export class SocialSecurityComponent implements OnInit {

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private commonService : CommonService,
    public dialog: MatDialog,
  ) { }

  ngOnInit(): void {
  }

  navigateFromLogin() {
    let isLoggedIn = localStorage.getItem('isLoggedIn');

    if (isLoggedIn === "true") {
      this.router.navigate(['/user-history'])
    } else {
      alert("No History Found, Please login");
      this.router.navigate(['/login'])

    }
  }

  navigateMenu(){
    this.router.navigate(['/search1-screen']);
    console.log("navigateMenu")
  }

  openModal(){
    const buttonModal = document.getElementById("openModalButton")
    console.log('buttonModal', buttonModal)
    buttonModal.click()
  }

  navigateToTaxPrep(){
    this.router.navigate(['/tax-prep'])
  }

}
